import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import moment from 'moment';
import 'moment/locale/es';
import ImageViewer from './ImageViewer';

// Texto que acompaña a cada foto: de qué bulto es, quién la sacó y cuándo.
export const packagePhotoCaption = (photo) => {
    const quien = photo?.captured_by?.name || 'Usuario desconocido';
    const cuando = photo?.captured_at ? moment(photo.captured_at).format('DD/MM/YYYY HH:mm') : '';
    return `Bulto ${photo?.position} · Tomada por ${quien}${cuando ? ` · ${cuando}` : ''}`;
};

// Fotos de los bultos que se sacaron en la app al terminar de pickear (OrderPackagePhoto
// en el backend). `load` es la función que las trae: la del pedido o la de la entrega.
const PackagePhotos = ({ load, emptyText }) => {
    const [photos, setPhotos] = useState(null);
    const [viewerAt, setViewerAt] = useState(null);

    useEffect(() => {
        let vivo = true;
        load()
            .then((data) => { if (vivo) setPhotos(Array.isArray(data) ? data : []); })
            .catch(() => { if (vivo) setPhotos([]); });
        return () => { vivo = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (photos === null) return <CircularProgress size={20} />;
    if (photos.length === 0) {
        return emptyText ? <Typography variant="body2" color="text.secondary">{emptyText}</Typography> : null;
    }

    return (
        <React.Fragment>
            <Grid container spacing={2}>
                {photos.map((photo, i) => (
                    <Grid item xs={6} sm={4} md={3} key={photo.id}>
                        <Box
                            component="img"
                            src={photo.url}
                            alt={`Bulto ${photo.position}`}
                            onClick={() => setViewerAt(i)}
                            sx={{ width: '100%', aspectRatio: '1', objectFit: 'cover', borderRadius: 1, cursor: 'pointer', display: 'block' }}
                        />
                        <Typography variant="caption" sx={{ display: 'block', fontWeight: 600, mt: 0.5 }}>
                            Bulto {photo.position}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.3 }}>
                            Tomada por {photo.captured_by?.name || 'usuario desconocido'}
                        </Typography>
                        {photo.captured_at &&
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.3 }}>
                                {moment(photo.captured_at).format('DD/MM/YYYY HH:mm')}
                            </Typography>
                        }
                    </Grid>
                ))}
            </Grid>
            <ImageViewer
                title="Fotos de bultos"
                isOpen={viewerAt !== null}
                startAt={viewerAt || 0}
                onClose={() => setViewerAt(null)}
                images={photos.map((photo) => ({ url: photo.url, caption: packagePhotoCaption(photo) }))} />
        </React.Fragment>
    );
};

export default PackagePhotos;
